export enum Routes {
  ResumeScreening = '/growth-center/resume-screening',
  ResumeScreeningSetup = '/growth-center/resume-screening/setup',
  EmailDripCampaign = '/growth-center/email-drip-campaign',
  EmailDripCampaignSetup = '/growth-center/email-drip-campaign/setup',
  Communication = '/growth-center/communication',
  CommunicationSetup = '/growth-center/communication/setup',
  OneOffResumeScreening = '/growth-center/resume-screening/job',
  OnboardingControlPanel = '/growth-center/onboarding-control-panel',
  Sms = '/growth-center/sms',
  SmsSetup = '/growth-center/sms/setup',
  JobPost = '/growth-center/job-post',
  JobPostSetup = '/growth-center/job-post/setup',
  CommunicationsHistory = '/growth-center/communications-history',
  TemplatesLibrary = '/growth-center/templates',
  TemplateSetup = '/growth-center/templates/setup',
}
